/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The identifier of a cloud provider.
 */
export var CloudProvider;
(function (CloudProvider) {
    CloudProvider["AWS"] = "aws";
    CloudProvider["GCP"] = "gcp";
    CloudProvider["AZURE"] = "azure";
    CloudProvider["OVH"] = "ovh";
    CloudProvider["OTHER"] = "other";
})(CloudProvider || (CloudProvider = {}));
//# sourceMappingURL=CloudProvider.js.map